const PREFIX = "COMMON_PDF";

export const commonActionTypes = {
  discard: `${PREFIX}_DISCARD`,
};
